export default {
  show() {},
  hide() {
    const splash = document.getElementById("splash");
    if (splash && splash.parentNode) {
      splash.parentNode.removeChild(splash);
    }
  },
};
